export const newsLetterTranslation = {
  en: {
    "Newsletter Subscription": "Newsletter Subscription",
    "Add Subscription": "Add Subscription",
    "Edit Subscription": "Edit Subscription",
    "Update Subscription": "Update Subscription",
    "Search by email": "Search by email...",
    Email: "Email",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    "S.No": "S.No",
    Actions: "Actions",
    Delete: "Delete",
    Cancel: "Cancel",
    "Created At": "Created At",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Add New Subscription": "Add New Subscription",
    "Are you sure you want to delete subscription '{{email}}'?":
      "Are you sure you want to delete subscription '{{email}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
  },
  ar: {
    "Newsletter Subscription": "اشتراك النشرة الإخبارية",
    "Add Subscription": "إضافة اشتراك",
    "Edit Subscription": "تعديل الاشتراك",
    "Update Subscription": "تحديث الاشتراك",
    "Search by email": "البحث حسب البريد الإلكتروني...",
    Email: "البريد الإلكتروني",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    "S.No": "م.",
    Actions: "الإجراءات",
    Delete: "حذف",
    Cancel: "إلغاء",
    "Created At": "تاريخ الإنشاء",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Add New Subscription": "إضافة اشتراك جديد",
    "Are you sure you want to delete subscription '{{email}}'?":
      "هل أنت متأكد أنك تريد حذف الاشتراك '{{email}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
  },
};
